import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Karşılaşılan sorunlar" className="border-y border-grape/10 bg-white/70" data-id="element-104" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: '8px',
      paddingTop: "11px"
    }} data-id="element-105" data-mp="26xwk8vgou5mv">
        <h2 className="text-center font-display text-[25px] font-black text-plum sm:text-4xl" data-id="element-106" data-mp="2bvoe3v0w81tp">
          Bu durum size tanıdık geliyor mu?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-plum/70" data-id="element-107" data-mp="21zlaslub1x56">
          Mesleğinizi seviyorsunuz. Ancak bir rapor yazmak için bilgisayarın başına geçtiğinizde teknik
          terminoloji, karmaşık belgeler, olayların kronolojik sıralaması ve eksik bilgi endişesi yüzünden
          gereğinden fazla zaman harcıyor olabilirsiniz.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-grape" data-id="element-108" data-mp="3nco4um7le8lm">
          Sorun mesleki becerilerinizin eksik olması değildir. İhtiyacınız olan şey{' '}
          <span className="text-blush" data-id="element-109" data-mp="1yykhbo9v9s5z">açık bir raporlama çerçevesidir</span>.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-110" data-mp="1u1bwth18xc1k">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-grape/15 bg-cream p-5" style={{
          paddingTop: "10px",
          paddingBottom: "10px"
        }} data-id="element-111" data-mp="27sgzkrzwukg4" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-lilac-soft text-sm" aria-hidden="true" data-id="element-112" data-mp="1k3e8ktjdzf8y">
                {p.emoji}
              </span>
              <div data-id="element-113" data-mp="30jh557dw3w9w">
                <h3 className="text-sm font-bold text-plum" data-id="element-114" data-mp="2vitc6g63p5d1">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-115" data-mp="2vkxfox0382cs">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-116" data-mp="1y3gk6ib856e6">
          <p className="font-display text-2xl font-bold text-plum sm:text-3xl" data-id="element-117" data-mp="1y6ck2c6mu559">
            ✨ Bu sorunlardan herhangi biri size tanıdık geliyorsa SIGMA SMART™ pratik bir çözüm sunar.
          </p>
        </div>
      </div>
    </section>;
}